import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

export default class HorizontalRule extends Component {
  static defaultProps = {
    'margin': 40,
  }

  render() {
    const styles = StyleSheet.create({
      container: {
        position: 'relative',
        marginTop: this.props.margin,
        marginBottom: this.props.margin,
      },
      line: {
        height: 1,
        backgroundColor: Theme.horizontal_rule_color,
        opacity: 0.45,
      },
    });

    return (
      <div className={css(styles.container)}>
        <div className={css(styles.line)} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HorizontalRule/index.js